var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isCarrierIconConfigured ? _c('span') : _vm.icon.startsWith('fas ') ? _c('font-awesome-icon', {
    staticClass: "text-primary",
    attrs: {
      "icon": _vm.icon
    }
  }) : _c('img', {
    attrs: {
      "src": `/${_vm.icon}`,
      "alt": ""
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }